<template>
   <v-container v-use-case="'DeltaCustomMonthlyCalculation'">
       <v-breadcrumbs :items="itemsForNavigation" style="padding: 5px 0px;"></v-breadcrumbs>
  <v-row no-gutters> 
    <v-col md="2" offset-md="5">
      <v-sheet>
        <v-col cols="">
         <FormBuilder 
            :formElements="formElements" 
            @formSubmit="fn"
            :useCancel="false"
            :loading="showLoader">
                     <v-col cols="12">
            <DateTimePickerFilter
              :error="dateErrors"
              :blockedIntervals="blockedIntervals"
              v-model="dateObj"
            ></DateTimePickerFilter>
          </v-col>
           </FormBuilder>
    </v-col>
    </v-sheet>
    </v-col>
  </v-row>
   </v-container>
  

</template>

<script>
import DateTimePickerFilter from '@/components/v2/DateTimePickerFilter'
import ProbeCalibrationValuesInput from '@/components/v2/customInputs/ProbeCalibrationValuesInput'
import httpClient from '@/api/httpClient'
export default {
  components: {
    ProbeCalibrationValuesInput,
    DateTimePickerFilter
  },
  data() {
    return {
      itemsForNavigation: [
        {
          text: this.$t('navigation.reports.Reports'),
          disabled: true
        },
        {
          text: this.$t('navigation.reports.Custom reports'),
          disabled: true
        }
      ],
      showLoader: false,
      dateErrors: '',
      blockedIntervals: [],
      dateObj: {},
      ids: [],
      vehicles: [],
      choosenVehicle: {},
      formElements: [
        {
          key: 'omvFilePath',
          component: 'v-image-upload',
          label: '$omv',
          props: {
            multiple: false,
            uploadType: 1,
            alowedFileTypes: ['xlsx', 'xls'],
            alowedFileSize: 123000,
            label: 'Icon file',
            uploadFolder: 'icons',
            rules: 'required|ext:xls,xlsx'
          }
        },
        {
          key: 'deltaFilePath',
          component: 'v-image-upload',
          label: '$delta',
          props: {
            multiple: false,
            uploadType: 1,
            alowedFileTypes: ['xlsx', 'xls'],
            alowedFileSize: 123000,
            label: 'Icon file',
            uploadFolder: 'icons',
            rules: 'required|ext:xls,xlsx'
          }
        },
        {
          key: 'type',
          component: 'v-autocomplete',
          label: '$type',
          props: {
            multiple: false
          },
          dataSource: [
            { text: '$passengerVehicles', value: 1 },
            { text: '$trucks', value: 2 }
          ]
        }
      ]
    }
  },
  methods: {
    fn(item) {
      var that = this
      that.showLoader = true
      httpClient({
        url: '/reports/DeltaCustomMonthlyCalculation',
        method: 'POST',
        responseType: 'blob',
        data: {
          ...item,
          ...this.dateObj
        }
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            'report-' + new Date().getTime().toString() + '.xlsx'
          )
          document.body.appendChild(link)
          link.click()
          that.showLoader = false
        })
        .catch(function(error) {
          that.showLoader = false
          alert('Došlo je do greške. Proverite format excel dokumenata.')
          if (error.response) {
            // Request made and server responded
            console.log(error.response.data)
            console.log(error.response.status)
            console.log(error.response.headers)
          } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request)
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message)
          }
        })
    }
  }
}
</script>
<style>
</style>
